<template>
    <footer id="footer-avaliacoes">
        <div id="rate-us-intro">
            <p>Avalie também a Chico Rei.</p>
            <p>Clique no botão abaixo para avaliar a sua experiência conosco.</p>
        </div>
        <div id="rate-us-card">
            <div id="logo-wrapper">
                <i class="icon-cr icon-logo-symbol-cr" />
                <i class="icon-cr icon-logo-cr" />
            </div>
            <AvaliacoesShowStars :stars-rating="5" />
        </div>
    </footer>
</template>

<script>
    import AvaliacoesShowStars from './AvaliacoesShowStars.vue';
    import StarsComponent from './form-components/StarsComponent.vue';

    export default {
        name: 'AvaliacoesFooter',
        data() {
            return {
                stars: [false, false, false, false, false],
                starsCount: 0,
            };
        },
        components: { StarsComponent, AvaliacoesShowStars },
    };
</script>
